"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoStream = void 0;
const react_1 = __importStar(require("react"));
const resize_observer_1 = require("@juggle/resize-observer");
const use_async_effect_1 = __importDefault(require("use-async-effect"));
const platform_sdk_1 = require("@pureweb/platform-sdk");
const Log_1 = __importDefault(require("../Log"));
const onresize = (videoRef, emitter, resolution) => {
    if (videoRef.current == null || emitter == null) {
        return;
    }
    const size = calculateGameSize(videoRef, resolution);
    emitter.EmitResize(size.width, size.height);
};
const calculateGameSize = (videoRef, resolution) => {
    if (videoRef.current == null) {
        return null;
    }
    const dpi = window.devicePixelRatio;
    let targetWidth = videoRef.current.clientWidth * dpi;
    let targetHeight = videoRef.current.clientHeight * dpi;
    if (resolution.fixed === true) {
        targetWidth = resolution.width;
        targetHeight = resolution.height;
    }
    let maxWidth = 0;
    let maxHeight = 0;
    let calculatedWidth = 0;
    let calculatedHeight = 0;
    const targetRatio = targetWidth / targetHeight;
    if (targetWidth > targetHeight) {
        maxWidth = 1920;
        maxHeight = 1080;
    }
    else {
        maxWidth = 1080;
        maxHeight = 1920;
    }
    const maxRatio = maxWidth / maxHeight;
    if (targetRatio > maxRatio) {
        calculatedWidth = Math.min(targetWidth, maxWidth);
        calculatedHeight = calculatedWidth / targetRatio;
    }
    else {
        calculatedHeight = Math.min(targetHeight, maxHeight);
        calculatedWidth = calculatedHeight * targetRatio;
    }
    const s = { width: calculatedWidth, height: calculatedHeight };
    return s;
};
exports.VideoStream = (props) => {
    var _a;
    const videoRef = (_a = props.VideoRef) !== null && _a !== void 0 ? _a : react_1.useRef(null);
    react_1.useEffect(() => {
        platform_sdk_1.attachKeyInput(props.ReservedKeys, props.Emitter);
        platform_sdk_1.attachMouseInput(videoRef.current, props.Emitter, props.UseNativeTouchEvents, props.UsePointerLock, props.PointerLockRelease);
    }, [props.ReservedKeys, props.Emitter, props.UseNativeTouchEvents, videoRef, props.UsePointerLock]);
    react_1.useEffect(() => {
        if (!videoRef.current) {
            return;
        }
        const resizeObserver = new resize_observer_1.ResizeObserver(() => onresize(videoRef, props.Emitter, props.Resolution));
        window.onorientationchange = () => {
            onresize(videoRef, props.Emitter, props.Resolution);
        };
        resizeObserver.observe(videoRef.current);
        return function cleanup() {
            resizeObserver.disconnect();
        };
    }, [videoRef.current, props.Emitter, props.Resolution]);
    use_async_effect_1.default(() => __awaiter(void 0, void 0, void 0, function* () {
        let isPlaying = false;
        videoRef.current.onplaying = () => {
            isPlaying = true;
        };
        videoRef.current.onpause = () => {
            isPlaying = false;
        };
        if (videoRef.current &&
            !isPlaying &&
            props.Stream !== undefined &&
            props.Stream !== null &&
            props.Stream !== videoRef.current.srcObject) {
            videoRef.current.oncanplay = () => {
                videoRef.current.play();
            };
            videoRef.current.muted = true;
            videoRef.current.defaultMuted = true;
            videoRef.current.setAttribute('muted', '1');
            videoRef.current.srcObject = props.Stream;
            try {
                onresize(videoRef, props.Emitter, props.Resolution);
            }
            catch (err) {
                Log_1.default.debug(err);
            }
        }
    }), [videoRef.current, props.Stream]);
    return react_1.default.createElement("video", { muted: true, playsInline: true, ref: videoRef });
};
exports.VideoStream.defaultProps = {
    Resolution: {
        fixed: false,
        width: 1920,
        height: 1080
    },
    ReservedKeys: ['F5', 'F11', 'Escape'],
    UseNativeTouchEvents: false,
    UsePointerLock: true,
    PointerLockRelease: true
};
//# sourceMappingURL=VideoStream.js.map